import { ActionIcon, NavLink, Popover, PopoverTarget, Tooltip } from '@mantine/core';
import { IconEye, IconSpeakerphone } from '@tabler/icons-react';
import * as React from 'react';
import { SystemAnnouncementOutline } from '../../../../resource/outlines/systemAnnouncementOutline';
import { TOOLTIPS } from '../../../../resource/tooltipTexts';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { SystemAnnouncementDialog } from './SystemAnnouncementDialog';
import { useUserId } from '../../../authentication/useUserId';
import {
    useSystemAnnouncementActions,
} from '../../../../resource/resources/persistables/system/announcement/systemAnnouncementResource';

export const SystemAnnouncementButton = () => {
    const [opened, setOpened] = React.useState(false);
    const nestedDialogFunction = useNestedDialogFunction();
    const userId = useUserId('');

    const systemAnnouncementActions = useSystemAnnouncementActions();

    const systemAnnouncements = systemAnnouncementActions.useGetAllActiveSystemAnnouncements(userId);

    const openAnnouncement = (id: string) => {
        nestedDialogFunction.showNestedDialog(<SystemAnnouncementDialog id={id} needsDismiss={false}
                                                                        onClose={nestedDialogFunction.closeNestedDialog} />);
    };

    if (!systemAnnouncements.data?.length) {
        return <div />;
    }

    return (
        <>
            <Popover opened={opened && Boolean(systemAnnouncements.data?.length)} onChange={setOpened}>
                <PopoverTarget>
                    <Tooltip label={TOOLTIPS.SYSTEM_ANNOUNCEMENT}>
                        <ActionIcon
                            color={
                                (
                                    systemAnnouncements.data.find(
                                        (value: SystemAnnouncementOutline) => !value.dismissed,
                                    )
                                ) ?
                                    'var(--mantine-color-error)'
                                    : 'inherit'
                            }
                            className={'titlebar-button'}
                            size={'sm'}
                            variant={'transparent'}
                            pr={18}
                            pl={12}
                            onClick={() => setOpened((o) => !o)}
                        >
                            <IconSpeakerphone />
                        </ActionIcon>
                    </Tooltip>
                </PopoverTarget>
                <Popover.Dropdown>
                    {systemAnnouncements.data?.map((value) => (
                        <NavLink
                            key={value.id}
                            miw={400}
                            rightSection={
                                <ActionIcon
                                    color={'var(--mantine-color-base-button)'}
                                    variant={'transparent'}
                                    size={'sm'}
                                    onClick={() => openAnnouncement(value.id)}
                                >
                                    <IconEye />
                                </ActionIcon>
                            }
                            label={value.title}
                        />
                    ))}
                </Popover.Dropdown>
            </Popover>
        </>
    );
};


